import store from '../../../admin/store'
import { CLEAN_IMAGE_CROPPER } from '../../../admin/reducers/image-cropper'
import i18n from '../../../locales/i18n'

/**
 * On modal close handler
 *
 * @param {Function|null} onSuccess
 */
export const onModalClose = (onSuccess = null) => {
    const imageSrc = store.getState().imageCropper.imageSrc
    if (imageSrc) {
        window.swconfirm({
            title: i18n.t('imageUpload.dropChanges'),
            onConfirm: () => Promise.resolve()
                .then(() => (
                    store.dispatch({
                        type: CLEAN_IMAGE_CROPPER,
                    })
                ))
                .then(() => typeof onSuccess === 'function' ? onSuccess?.() : {}),
            onCancel: () => {},
        })

        return
    }

    store.dispatch({
        type: CLEAN_IMAGE_CROPPER,
    })

    if (typeof onSuccess === 'function') {
        onSuccess()
    }
}
